"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _immutable = require("immutable");
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _Question = _interopRequireDefault(require("../factories/Question.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_Question.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.QUESTION_PRELOADED] = stateHelper.set;
reducers[_constants.QUESTION_FETCHED] = stateHelper.set;
reducers[_constants.SEARCH_QUESTIONS_FETCHED] = stateHelper.set;
reducers[_constants.QUESTION_RESULTS_FETCHED] = stateHelper.set;
reducers[_constants.QUIZ_QUESTION_FETCHED_NEXT] = stateHelper.set;
reducers[_constants.QUESTION_EXCERPTS_FETCHED] = function (state, payload) {
  return payload.questionArrays.reduce(function (prevState, questionArray) {
    return prevState.setIn([questionArray[0], 'plain_name'], questionArray[1]);
  }, state);
};

// Non-Questions Action Reducers
reducers[_constants.QUIZ_CREATED] = stateHelper.resetAndSet;
reducers[_constants.QUIZ_FETCHED_TAKE] = stateHelper.resetAndSet;
reducers[_constants.QUIZ_UNLOAD_QUESTIONS_AND_RESPONSES] = function (state, payload) {
  var isAdaptive = payload.isAdaptive,
    questionIds = payload.questionIds;
  if (isAdaptive) {
    questionIds.forEach(function (questionId) {
      // eslint-disable-next-line no-param-reassign
      state = state.set(questionId, new _immutable.Map({
        plain_name: state.getIn([questionId, 'plain_name'])
      }));
    });
  }
  return state;
};
reducers[_constants.QUIZ_FETCHED_QUESTIONS] = function quizFetchedQuestions(state, payload) {
  var newState = state;
  newState = stateHelper.set(newState, payload);
  var difficultyLevels = payload.difficultyLevels;
  if (difficultyLevels) {
    // Replace difficulty level returned from the endpoint with correct value from performanceQuestions slice of state
    var questionIds = newState.toList().toArray().map(function (question) {
      return question.get('id');
    });
    questionIds.forEach(function (questionId) {
      var difficultyRecord = difficultyLevels.find(function (record) {
        return record.id === parseInt(questionId);
      });
      if (difficultyRecord) {
        var difficulty = difficultyRecord.difficulty;
        newState = newState.setIn([parseInt(questionId), 'difficulty_level'], difficulty);
      }
    });
  }
  return newState;
};
reducers[_constants.SESSION_RESET] = stateHelper.reset;
reducers[_constants.QUESTION_BANK_SELECTED] = stateHelper.reset;
reducers[_constants.OFFLINE_QUIZ_LOADED] = function offlineQuizLoaded(state, payload) {
  var newState = (0, _immutable.Map)();
  payload.questions.forEach(function (question) {
    newState = newState.set(question.get('id'), question);
  });
  return newState;
};
var _default = exports.default = stateHelper.createReducer(reducers);